import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconAsset';

export const Section = styled.section`
  ${tw`bg-ui-colours-ui1`}
  ${tw`py-8 md:py-[128px]`}
`;

export const Container = styled.div`
  ${tw`lg:container-stack-context`}
  ${tw`py-7 px-2 lg:py-0 lg:px-0`}
  ${tw`grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-x-8 md:gap-y-3`}
`;

export const SuccessContainer = styled.div`
  ${tw`container container-stack-context`}
  ${tw`flex flex-col-reverse md:flex-row md:gap-8 items-center`}
  ${tw`py-4 px-2 md:px-12 md:py-10`}
`;

export const SuccessIcon = styled(Icon)`
  ${tw`w-[80px] md:h-auto md:w-auto`}
`;

export const StyledWrapper = styled.div`
  ${tw`backdrop-blur bg-neutrals-n1`}
  ${tw`lg:rounded-xl`}
  ${tw`lg:container lg:container-stack-context`}
  ${tw`lg:px-12 lg:py-10`}
`;

export const InformationBlock = styled.div`
  ${tw`flex flex-col items-center`}
  ${tw`md:items-start`}
`;

export const IconContainer = styled.div`
  ${tw`mb-3 flex`}
  ${tw`md:col-span-2`}
`;

export const StyledIcon = styled(Icon)`
  ${tw`w-64 h-8 mx-auto`}
  ${tw`text-[transparent]`}
  ${tw`md:mx-0`}
`;

export const Headline = styled.h2`
  ${tw`font-poppins`}
  ${tw`font-semi-bold`}
  ${tw`text-primary-p1`}
  ${tw`text-heading-s`}
  ${tw`text-center md:text-left`}
  ${tw`mb-2 md:mb-3`}
`;

export const SuccessHeadline = styled.h2`
  ${tw`font-poppins`}
  ${tw`font-semi-bold`}
  ${tw`text-secondary-s1`}
  ${tw`text-mobile-heading-m md:text-display-xl`}
  ${tw`text-center md:text-left`}
  ${tw`mb-2 md:mb-3`}
`;

export const Content = styled.div`
  ${tw`text-primary-p1`}
  ${tw`text-body-s md:text-body-l`}
  ${tw`font-inter font-regular`}
  ${tw`text-center md:text-left`}

  sub {
    ${tw`hidden`}
    ${tw`text-body-s`}
    ${tw`md:inline`}
  }
`;

export const FormContainer = styled.div<{ hasDropShadow?: boolean }>`
  ${tw`flex flex-col justify-center`}
  ${tw`rounded-xl bg-ui-colours-ui1`}
  ${({ hasDropShadow }) =>
    hasDropShadow && tw`shadow-[12px 12px 0px 0px #290042;] border-4 border-primary-p1`}
  ${tw`p-4`}
`;
